function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }

function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }

function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }

function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }

function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

var _timeline = /*#__PURE__*/new WeakMap();

var _init = /*#__PURE__*/new WeakMap();

var _createAnimationTimelines = /*#__PURE__*/new WeakMap();

var MobileMenuDrawer = /*#__PURE__*/function () {
  function MobileMenuDrawer(options) {
    var _this = this;

    _classCallCheck(this, MobileMenuDrawer);

    _defineProperty(this, "options", {
      selector: ".mobile-menu-drawer",
      duration: 0.4
    });

    _defineProperty(this, "element", null);

    _timeline.set(this, {
      writable: true,
      value: void 0
    });

    _defineProperty(this, "gsap", undefined);

    _init.set(this, {
      writable: true,
      value: function value() {
        _this.element = document.querySelector(_this.options.selector);

        if (!_this.element) {
          throw new Error("[MMD] No element found using the specified selector (".concat(_this.options.selector, ")"));
        }

        _classPrivateFieldGet(_this, _createAnimationTimelines).call(_this);
      }
    });

    _createAnimationTimelines.set(this, {
      writable: true,
      value: function value() {
        var duration = _this.options.duration;

        _this.timeline.fromTo(_this.element, {
          x: "0%"
        }, {
          x: "-100%",
          duration: duration
        });
      }
    });

    _defineProperty(this, "open", function () {
      _this.timeline.play();
    });

    _defineProperty(this, "close", function () {
      _this.timeline.reverse();
    });

    this.options = _objectSpread(_objectSpread({}, this.options), options);
    import('gsap').then(function (_ref) {
      var gsap = _ref.gsap;
      _this.gsap = gsap;
    }).then(function () {
      _classPrivateFieldGet(_this, _init).call(_this);
    });
  }

  _createClass(MobileMenuDrawer, [{
    key: "timeline",
    get: function get() {
      // Caching
      if (!_classPrivateFieldGet(this, _timeline)) {
        _classPrivateFieldSet(this, _timeline, this.gsap.timeline({
          paused: true
        }));
      }

      return _classPrivateFieldGet(this, _timeline);
    }
  }]);

  return MobileMenuDrawer;
}();

export { MobileMenuDrawer as default };